/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021-2023 (original work) Open Assessment Technologies SA ;
 */

//matches `^[\s\S]{0,10}$`
//groups: [max]   `max: 10`
const maxlengthRegex = /\^\[\\s\\S\]\{0,(\d+)\}\$/;

//matches `^anything{0,10}$`
//groups: [repeatedPattern, max]    `repeatedPattern: anything, max: 10`
const maxRegex = /^\^(.+?)\{0,(\d+)\}\$$/;

const maxWordsPatternContentWithoutMinMax =
    '(?:(?:[^\\s\\:\\!\\?\\;\\\u2026\\\u20ac]+)[\\s\\:\\!\\?\\;\\\u2026\\\u20ac]*)';
const maxWordsSeparators = '\\s.,:;?!&#%/*+='; //should be the same as in backend validation

/**
 * Check if this patternMask is a Maxlength patternMask generated by Autrhoring,
 * and if it is, return maxlength specified by this patternMask
 * @param {String} patternMask
 * @returns {Number?} maxlength if pattern is recognized, null if not
 */
export function tryParseMaxlength(patternMask) {
    if (patternMask) {
        const matches = patternMask.match(maxlengthRegex);
        if (matches && matches.length > 1) {
            return parseInt(matches[1], 10);
        }
    }
    return null;
}

/**
 * Check if this patternMask is a "Max words" patternMask generated by Authoring,
 * and if it is, return maxWords and word separators specified by this patternMask.
 * NB! word separators are hardcoded and aren't extracted from patternMask; this matches backend solution.
 * @param {String} patternMask
 * @returns {Object|null} - `{max: number, separators: string}`, or null if pattern is not recognized
 */
export function tryParseMaxWords(patternMask) {
    if (patternMask) {
        const matches = patternMask.match(maxRegex);
        if (matches && matches[1] === maxWordsPatternContentWithoutMinMax && matches[2]) {
            return {
                max: parseInt(matches[2], 10),
                separators: maxWordsSeparators
            };
        }
    }
    return null;
}
